<template>
  <a href="#" :class="customClasses" @click.prevent.stop="handleClick">
    <span class="header-toggle__text" aria-hidden="true">Toggle Menu</span>
    <div class="header-toggle__lines">
      <span class="header-toggle__line"></span>
      <span class="header-toggle__line"></span>
      <span class="header-toggle__line"></span>
      <span class="header-toggle__line"></span>
    </div>
  </a>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'HeaderToggle',
  data () {
    return {
      active: false
    }
  },
  computed: {
    ...mapGetters({
      toggle: 'header/getToggle'
    }),
    customClasses () {
      return [
        'header-toggle',
        { 'is-active': this.toggle }
      ]
    }
  },
  watch: {
    toggle () {
      this.active = this.toggle
    }
  },
  methods: {
    ...mapActions({
      updateToggle: 'header/updateToggle'
    }),
    handleClick () {
      this.active = !this.active
      this.updateToggle(this.active)
    }
  }

}
</script>

<style lang="scss">
.header-toggle {
  @include size(5rem);

  display: block;
  position: relative;
  padding: 1rem;
  z-index: 1000;
  background-color: rgba(black, 0.5);

  &.is-active {
    .header-toggle__lines {
      align-items: center;
    }

    .header-toggle__line {
      &:nth-of-type(1) {
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
        transform: translateX(50%);
      }
      &:nth-of-type(3) {
        opacity: 0;
        transform: translateX(-50%);
      }
      &:nth-of-type(4) {
        top: 50%;
        width: 100%;
        transform: translateY(-50%) rotate(-45deg);
      }
    }
  }

  // Text

  &__text {
    @include hide-visually();
  }

  // Lines

  &__lines {
    position: relative;
    width: 100%;
    height: 100%;
  }

  // Line

  &__line {
    width: 100%;
    height: .2rem;
    display: block;
    background-color: white;
    transform-origin: 50%;
    position: absolute;
    transition: all 300ms $ease-in-out-sine;

    &:nth-of-type(1) {
      top: 0.2rem;
    }
    &:nth-of-type(2) {
      top: 1rem;
    }
    &:nth-of-type(3) {
      top: 1.8rem;
    }
    &:nth-of-type(4) {
      top: 2.6rem;
      width: 50%;
    }
  }
}
</style>
